// ABOUTME: React Query hooks for hypothesis data
// ABOUTME: List all hypotheses and fetch individual analysis

import { useQuery } from '@tanstack/react-query'
import { hypothesesApi } from '@/api/hypotheses'

export const useHypotheses = (category?: string) => {
  return useQuery({
    queryKey: ['hypotheses', category],
    queryFn: () => hypothesesApi.getHypotheses(category),
    // Cache for 5 minutes
    staleTime: 5 * 60 * 1000,
  })
}

export const useHypothesisAnalysis = (category: string, hypothesisId: string) => {
  return useQuery({
    queryKey: ['hypothesis', category, hypothesisId],
    queryFn: () => hypothesesApi.getHypothesisAnalysis(category, hypothesisId),
    enabled: !!category && !!hypothesisId,
    // Cache for 15 minutes (analysis data doesn't change)
    staleTime: 15 * 60 * 1000,
  })
}
